module.exports = function(locale, preview) {
  return `
      {
          headerCollection(locale: "${locale}", limit: 1, preview: ${preview}) {
            items {
              countrySelectorsCollection {
                items {
                  sys {
                    id
                  }
                  countryName
                  countryWebsite
                  regionName
                }
              }
            }
          }
      } 
    `;
};
